import { Routes, Route, Navigate } from 'react-router-dom';
import useAuth from 'hooks/useAuth';

import IndexLayout from 'layouts/IndexLayout';
import MainLayout from 'layouts/MainLayout';
import AuthRoutes from 'components/AuthRoutes';
import IndexPage from 'pages/index/IndexPage';
import BankList from 'pages/bank/List';
import BankView from 'pages/bank/View';
import BankAdd from 'pages/bank/Add';
import BankEdit from 'pages/bank/Edit';
import ChargestblList from 'pages/chargestbl/List';
import ChargestblView from 'pages/chargestbl/View';
import ChargestblAdd from 'pages/chargestbl/Add';
import ChargestblEdit from 'pages/chargestbl/Edit';
import LoanamortList from 'pages/loanamort/List';
import LoanamortView from 'pages/loanamort/View';
import LoanamortAdd from 'pages/loanamort/Add';
import LoanamortEdit from 'pages/loanamort/Edit';
import LoanamortListadmin from 'pages/loanamort/Listadmin';
import LoanamortListvendor from 'pages/loanamort/Listvendor';
import LoanproductList from 'pages/loanproduct/List';
import LoanproductView from 'pages/loanproduct/View';
import LoanproductAdd from 'pages/loanproduct/Add';
import LoanproductEdit from 'pages/loanproduct/Edit';
import MandateworldList from 'pages/mandateworld/List';
import MandateworldView from 'pages/mandateworld/View';
import MandateworldAdd from 'pages/mandateworld/Add';
import MandateworldEdit from 'pages/mandateworld/Edit';
import MandateworldEditstep2 from 'pages/mandateworld/Editstep2';
import MandateworldEditstep3 from 'pages/mandateworld/Editstep3';
import MandateworldListadmin from 'pages/mandateworld/Listadmin';
import PermissionsList from 'pages/permissions/List';
import PermissionsView from 'pages/permissions/View';
import PermissionsAdd from 'pages/permissions/Add';
import PermissionsEdit from 'pages/permissions/Edit';
import RolesList from 'pages/roles/List';
import RolesView from 'pages/roles/View';
import RolesAdd from 'pages/roles/Add';
import RolesEdit from 'pages/roles/Edit';
import UsersList from 'pages/users/List';
import UsersView from 'pages/users/View';
import UsersAdd from 'pages/users/Add';
import UsersEdit from 'pages/users/Edit';
import UsersKycupdate from 'pages/users/Kycupdate';
import UsersListpending from 'pages/users/Listpending';
import VendordocsList from 'pages/vendordocs/List';
import VendordocsView from 'pages/vendordocs/View';
import VendordocsAdd from 'pages/vendordocs/Add';
import VendordocsEdit from 'pages/vendordocs/Edit';
import VendordocsListadmin from 'pages/vendordocs/Listadmin';
import VendorsList from 'pages/vendors/List';
import VendorsmandatesList from 'pages/vendorsmandates/List';
import VendorPage from 'pages/home/VendorPage';
import KycPage from 'pages/custom/KycPage';
import MandateverifyPage from 'pages/custom/MandateverifyPage';
import DebitpresentationPage from 'pages/custom/DebitpresentationPage';
import CreatemandatePage from 'pages/custom/CreatemandatePage';
import EnachauthPage from 'pages/custom/EnachauthPage';
import NozonePage from 'pages/custom/NozonePage';
import DebitverifyPage from 'pages/custom/DebitverifyPage';
import ChargessummaryPage from 'pages/custom/ChargessummaryPage';
import EnchmorePage from 'pages/custom/EnchmorePage';
import AccountPages from 'pages/account';
import HomePage from './pages/home/HomePage';
import IndexPages from './pages/index';
import ErrorPages from './pages/errors';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import 'primeflex/primeflex.css';
import 'assets/styles/layout.scss';
import VerifyOtp from './pages/index/VerifyOtp';
import Confirmation from './pages/index/confirmation';
import EnachResponse from './pages/custom/Enachresponse';
import resetpassword_completed from "./pages/index/ResetPasswordCompleted";
import resetpassword from "./pages/index/ResetPassword";
import PrivacypolicyPage from 'pages/custom/PrivacypolicyPage';

const App = () => {
	const auth = useAuth();
	function DefaultPage(){
		if(!auth.isLoggedIn){
			return <IndexPage />
		}
		return <Navigate to="/home" replace />;
	}
	function UserRoleHomePage(){
		const userRole = (auth.userRole || '').toLowerCase();
		switch(userRole){
			case 'vendor':
				return <VendorPage />
			default:
				return <HomePage />;
		}
	}
	return (
		<Routes>
			<Route exact element={<AuthRoutes />}>
			<Route element={<MainLayout />}>
				<Route path="/home" element={<UserRoleHomePage />} />
				

				{/* bank pages routes */}
				<Route path="/bank" element={<BankList />} />
				<Route path="/bank/:fieldName/:fieldValue" element={<BankList />} />
				<Route path="/bank/index/:fieldName/:fieldValue" element={<BankList />} />
				<Route path="/bank/view/:pageid" element={<BankView />} />
				<Route path="/bank/add" element={<BankAdd />} />
				<Route path="/bank/edit/:pageid" element={<BankEdit />} />

				{/* chargestbl pages routes */}
				<Route path="/chargestbl" element={<ChargestblList />} />
				<Route path="/chargestbl/:fieldName/:fieldValue" element={<ChargestblList />} />
				<Route path="/chargestbl/index/:fieldName/:fieldValue" element={<ChargestblList />} />
				<Route path="/chargestbl/view/:pageid" element={<ChargestblView />} />
				<Route path="/chargestbl/add" element={<ChargestblAdd />} />
				<Route path="/chargestbl/edit/:pageid" element={<ChargestblEdit />} />

				{/* loanamort pages routes */}
				<Route path="/loanamort" element={<LoanamortList />} />
				<Route path="/loanamort/:fieldName/:fieldValue" element={<LoanamortList />} />
				<Route path="/loanamort/index/:fieldName/:fieldValue" element={<LoanamortList />} />
				<Route path="/loanamort/view/:pageid" element={<LoanamortView />} />
				<Route path="/loanamort/add" element={<LoanamortAdd />} />
				<Route path="/loanamort/edit/:pageid" element={<LoanamortEdit />} />
				<Route path="/loanamort/listadmin" element={<LoanamortListadmin />} />
				<Route path="/loanamort/listadmin/:fieldName/:fieldValue" element={<LoanamortListadmin />} />
				<Route path="/loanamort/listvendor" element={<LoanamortListvendor />} />
				<Route path="/loanamort/listvendor/:fieldName/:fieldValue" element={<LoanamortListvendor />} />

				{/* loanproduct pages routes */}
				<Route path="/loanproduct" element={<LoanproductList />} />
				<Route path="/loanproduct/:fieldName/:fieldValue" element={<LoanproductList />} />
				<Route path="/loanproduct/index/:fieldName/:fieldValue" element={<LoanproductList />} />
				<Route path="/loanproduct/view/:pageid" element={<LoanproductView />} />
				<Route path="/loanproduct/add" element={<LoanproductAdd />} />
				<Route path="/loanproduct/edit/:pageid" element={<LoanproductEdit />} />

				{/* mandateworld pages routes */}
				<Route path="/mandateworld" element={<MandateworldList />} />
				<Route path="/mandateworld/:fieldName/:fieldValue" element={<MandateworldList />} />
				<Route path="/mandateworld/index/:fieldName/:fieldValue" element={<MandateworldList />} />
				<Route path="/mandateworld/view/:pageid" element={<MandateworldView />} />
				<Route path="/mandateworld/add" element={<MandateworldAdd />} />
				<Route path="/mandateworld/edit/:pageid" element={<MandateworldEdit />} />
				<Route path="/mandateworld/editstep2/:pageid" element={<MandateworldEditstep2 />} />
				<Route path="/mandateworld/editstep3/:pageid" element={<MandateworldEditstep3 />} />
				<Route path="/mandateworld/listadmin" element={<MandateworldListadmin />} />
				<Route path="/mandateworld/listadmin/:fieldName/:fieldValue" element={<MandateworldListadmin />} />

				{/* permissions pages routes */}
				<Route path="/permissions" element={<PermissionsList />} />
				<Route path="/permissions/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/index/:fieldName/:fieldValue" element={<PermissionsList />} />
				<Route path="/permissions/view/:pageid" element={<PermissionsView />} />
				<Route path="/permissions/add" element={<PermissionsAdd />} />
				<Route path="/permissions/edit/:pageid" element={<PermissionsEdit />} />

				{/* roles pages routes */}
				<Route path="/roles" element={<RolesList />} />
				<Route path="/roles/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/index/:fieldName/:fieldValue" element={<RolesList />} />
				<Route path="/roles/view/:pageid" element={<RolesView />} />
				<Route path="/roles/add" element={<RolesAdd />} />
				<Route path="/roles/edit/:pageid" element={<RolesEdit />} />

				{/* users pages routes */}
				<Route path="/users" element={<UsersList />} />
				<Route path="/users/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/index/:fieldName/:fieldValue" element={<UsersList />} />
				<Route path="/users/view/:pageid" element={<UsersView />} />
				<Route path="/users/add" element={<UsersAdd />} />
				<Route path="/users/edit/:pageid" element={<UsersEdit />} />
				<Route path="/users/kycupdate" element={<UsersKycupdate />} />
				<Route path="/users/kycupdate/:fieldName/:fieldValue" element={<UsersKycupdate />} />
				<Route path="/users/listpending" element={<UsersListpending />} />
				<Route path="/users/listpending/:fieldName/:fieldValue" element={<UsersListpending />} />

				{/* vendordocs pages routes */}
				<Route path="/vendordocs" element={<VendordocsList />} />
				<Route path="/vendordocs/:fieldName/:fieldValue" element={<VendordocsList />} />
				<Route path="/vendordocs/index/:fieldName/:fieldValue" element={<VendordocsList />} />
				<Route path="/vendordocs/view/:pageid" element={<VendordocsView />} />
				<Route path="/vendordocs/add" element={<VendordocsAdd />} />
				<Route path="/vendordocs/edit/:pageid" element={<VendordocsEdit />} />
				<Route path="/vendordocs/listadmin" element={<VendordocsListadmin />} />
				<Route path="/vendordocs/listadmin/:fieldName/:fieldValue" element={<VendordocsListadmin />} />

				{/* vendors pages routes */}
				<Route path="/vendors" element={<VendorsList />} />
				<Route path="/vendors/:fieldName/:fieldValue" element={<VendorsList />} />
				<Route path="/vendors/index/:fieldName/:fieldValue" element={<VendorsList />} />

				{/* vendorsmandates pages routes */}
				<Route path="/vendorsmandates" element={<VendorsmandatesList />} />
				<Route path="/vendorsmandates/:fieldName/:fieldValue" element={<VendorsmandatesList />} />
				<Route path="/vendorsmandates/index/:fieldName/:fieldValue" element={<VendorsmandatesList />} />
				<Route path="/vendor" element={<VendorPage />} />
				<Route path="/kyc" element={<KycPage />} />
				<Route path="/mandateverify" element={<MandateverifyPage />} />
				<Route path="/debitpresentation" element={<DebitpresentationPage />} />
				<Route path="/createmandate" element={<CreatemandatePage />} />
				<Route path="/enachauth" element={<EnachauthPage />} />
				<Route path="/nozone" element={<NozonePage />} />
				<Route path="/debitverify" element={<DebitverifyPage />} />
				<Route path="/chargessummary" element={<ChargessummaryPage />} />
				<Route path="/enchmore" element={<EnchmorePage />} />
				<Route path="/account/*" element={<AccountPages />} />
			</Route>
			</Route>
						<Route exact element={<IndexLayout />}>
				<Route path="/" element={<DefaultPage />} />
				<Route path="/*" element={<IndexPages />} />
				<Route path="/error/*" element={<ErrorPages />} />
				<Route path="/index/verifyotp" element={<VerifyOtp />} />
				<Route path="/index/confirmation" element={<Confirmation />} /> 
				 <Route path="/EnachResponse" element={<EnachResponse />} />
				 {/* <Route path="/ResetPassword" element={<resetpassword />} /> */}
				 <Route path="/ResetPasswordCompleted" element={<resetpassword_completed />} />
				 <Route path="/Privacypolicy" element={<PrivacypolicyPage />} />

			</Route>

		</Routes>
	);
}
export default App;
